module.exports = __webpack_public_path__ + "static/media/communications.897e6148.jpg";